import React from 'react';
import { Popup } from 'semantic-ui-react';
import ButtonWrapper from './ButtonWrapper';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { changesNotificationModalActions } from '../../behavior/changesNotificationModal';
type Props = {
  setValidateOnChange: (arg0: boolean) => void;
  toggleValidationMessage: () => void;
  setMarkAsChecked: () => void;
  submitForm: () => Promise<unknown> | void;
};
type PropsForTrigger = {
  onClick: () => void;
  label: string;
};
const MarkAsCheckedTrigger = ({ onClick, label }: PropsForTrigger) => (
  <ButtonWrapper onClick={onClick} label={label} primary={true} icon="checkmark" />
);
function MarkAsCheckedButton({
  setValidateOnChange,
  toggleValidationMessage,
  setMarkAsChecked,
  submitForm,
}: Props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleClick = async () => {
    setValidateOnChange(true);
    toggleValidationMessage();
    setMarkAsChecked();
    try {
      await submitForm();
    } finally {
      // Formik can finish without onSubmit when client-side validation fails.
      dispatch(changesNotificationModalActions.setMarkAsChecked(false));
    }
  };
  return (
    <Popup
      key="mark.as.checked.button.key.tooltip"
      wide="very"
      icon="check"
      trigger={
        <MarkAsCheckedTrigger
          onClick={handleClick}
          label={t(`details.page.mark.as.checked.button`)}
        />
      }
      on={['hover']}
      size="mini"
      content={t('details.page.mark.as.checked.button.tooltip')}
      position="bottom right"
    />
  );
}
export default MarkAsCheckedButton;
